import React, { useEffect, useState } from "react";
import { GetRecords } from "../../functions/api";

const CompanyList = ({ onCompanySelect }) => {
    const init = {
        company_id: "",
    };
    const initProps = {
        company_id: {
            company_id_list: [{ label: "Select Organization", value: "0" }],
        },
    };

    const [Record, setRecord] = useState(init);
    const [props, setprops] = useState(initProps);

    useEffect(() => {
        GetRecords(`/api/v2/accountingcompany/getallcompanies`).then((res) => {
            if (res.success) {
                res = res.record.list || [];
                let company_id_list = [...initProps.company_id.company_id_list];

                res?.forEach((group) => {
                    company_id_list.push({
                        value: group?.id || "",
                        label: group?.company_name || "",
                    });
                });

                // Update state with company list
                HandlePropsChange("company_id", { ...props.company_id, company_id_list });
            }
        });
    }, []);

    useEffect(() => {
        console.log("Record State change -> ", Record);
        console.log("Props State change -> ", props);
    }, [Record, props]);

    function handleFieldChange(fieldName, value) {
        onCompanySelect(value)
        setRecord((prev) => ({
            ...prev,
            [fieldName]: value,
        }));
    }

    function HandlePropsChange(fieldName, value = {}) {
        setprops((prev) => {
            let oldprop = prev[fieldName];

            for (let prophead in value) {
                oldprop[prophead] = value[prophead];
            }
            prev[fieldName] = oldprop;
            return { ...prev };
        });
    }

    return (
        <div className="relative w-[220px]">
            <select
                id="company_id"
                className="z-50 h-[32px] max-sm:h-fit max-sm:p-2 w-[220px] border rounded-lg text-base border-[#000048] hover:bg-tertiary hover:text-primary transition-colors duration-500 gap-1 shadow-md w-full border border-[#000048] rounded-lg px-4 py-1 outline-none focus:ring-2 focus:ring-blue-500 hover:text-primary transition-colors bg-[#FFFF] duration-500 shadow-md appearance-none"
                onChange={(event) => handleFieldChange("company_id", event.target.value)}
                value={Record.company_id}
            >
                {props.company_id.company_id_list.map((item, index) => (
                    <option key={index} value={item.value}>
                        {item.label}
                    </option>
                ))}
            </select>

            {/* ▼ Arrow Icon */}
            <span className="absolute inset-y-0 right-6 flex items-center pointer-events-none text-gray-600">
                ▼
            </span>
        </div>
    );
};

export default CompanyList;
